 (() => {
   'use strict';
   if (!document.body.classList.contains('product')) return;

   const priceSelector = '[data-price-ui] .money';

   const pricePattern = /^(.*?)(\d[\d,\s]*)(?:\.(\d{2}))(.*)$/;

   function formatPrice(priceElement) {
     if (priceElement.querySelector('.pb-price-major')) return;

     const priceText = priceElement.textContent.replace(/\s+/g, ' ').trim();
     const match = priceText.match(pricePattern);

     if (!match) return;

     const [, prefix, wholeDollars, cents, suffix] = match;

     if (cents === '00') {
       priceElement.textContent = `${prefix}${wholeDollars}${suffix}`;
       return;
     }

     const major = document.createElement('span');
     major.className = 'pb-price-major';
     major.textContent = `${prefix}${wholeDollars}`;

     const minor = document.createElement('span');
      const lastDigit = wholeDollars.replace(/\D/g, '').slice(-1);

 minor.className = `pb-price-cents${lastDigit === '1' ? ' pb-price-cents--after-one' : ''}`;
 minor.textContent = cents;


     priceElement.replaceChildren(major, minor, document.createTextNode(suffix));
   }

   function formatPrices(root = document) {
     if (root.nodeType === Node.ELEMENT_NODE && root.matches(priceSelector)) {
       formatPrice(root);
     }

     if (root.querySelectorAll) {
       root.querySelectorAll(priceSelector).forEach(formatPrice);
     }
   }

   function initialise() {
     formatPrices();

     let scheduled = false;

     const observer = new MutationObserver(() => {
       if (scheduled) return;

       scheduled = true;

       window.requestAnimationFrame(() => {
         scheduled = false;
         formatPrices();
       });
     });

     observer.observe(document.body, {
       childList: true,
       characterData: true,
       subtree: true
     });
   }

   if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', initialise);
   } else {
     initialise();
   }
 })();